export default __webpack_public_path__ + "static/media/notfound.08c36075.png";